import { ContentWrapper } from "@/components/layout/content";
import { ScrambleButton } from "@/components/ui/ScrambleButton";
import { GlitchText } from "@/components/ui/GlitchText";

export function HomepageHeroSection() {
  return (
    <div
      id="hero"
      className="w-full bg-transparent min-h-screen relative z-10 overflow-hidden flex items-center"
    >
      <ContentWrapper className="relative z-10 w-full pt-28 pb-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center w-full">
          <div className="lg:col-span-8 flex flex-col justify-center relative">
            {/* Soft, subtle radial dark overlay behind text to enhance readability */}
            <div
              className="absolute -inset-10 md:-inset-16 pointer-events-none rounded-full blur-3xl opacity-85"
              style={{
                background:
                  "radial-gradient(circle, color-mix(in srgb, var(--color-gray-950) 85%, transparent) 0%, color-mix(in srgb, var(--color-gray-950) 50%, transparent) 60%, transparent 100%)",
              }}
            />
            <div className="relative z-10 w-full">
              <h1 className="text-5xl md:text-7xl font-mono font-bold text-gray-100 mb-8 leading-tight">
                <GlitchText text="Lücken schließen." glitchClassName="text-emerald-400" />
                <br className="hidden md:block" />
                <span className="text-transparent bg-clip-text bg-linear-to-r from-emerald-400 to-cyan-500">
                  <GlitchText text="Digital." glitchClassName="text-cyan-400" />
                </span>
              </h1>

              <p className="text-lg md:text-2xl text-gray-300 font-mono font-bold leading-relaxed mb-4 max-w-2xl">
                Hi!
                <span className="inline-block animate-wave origin-[50%_50%] align-middle -mb-0.5 ml-1">
                  <span className="inline-block animate-glitch">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="w-6 h-6 md:w-8 md:h-8 text-emerald-400 stroke-emerald-400 fill-emerald-500/10 filter drop-shadow-[0_0_8px_rgba(16,185,129,0.3)]"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M10.05 4.575a1.575 1.575 0 1 0-3.15 0v3m3.15-3v-1.5a1.575 1.575 0 0 1 3.15 0v1.5m-3.15 0 .075 5.925m3.075.75V4.575m0 0a1.575 1.575 0 0 1 3.15 0V15M6.9 7.575a1.575 1.575 0 1 0-3.15 0v8.175a6.75 6.75 0 0 0 6.75 6.75h2.018a5.25 5.25 0 0 0 3.712-1.538l1.732-1.732a5.25 5.25 0 0 0 1.538-3.712l.003-2.024a.668.668 0 0 1 .198-.471 1.575 1.575 0 1 0-2.228-2.228 3.818 3.818 0 0 0-1.12 2.687M6.9 7.575V12m6.27 4.318A4.49 4.49 0 0 1 16.35 15m.002 0h-.002"
                      />
                    </svg>
                  </span>
                </span>{" "}
                Ich bin Johann.
              </p>

              <p className="text-lg md:text-xl text-gray-300 font-sans leading-relaxed mb-12 max-w-2xl">
                Full-Stack Webentwickler, UI-Designer und Fotograf aus Karlsruhe. Von robusten
                Webseiten und Softwarelösungen bis hin to Printmedien und Visuals - ich bringe Ideen
                mit klarer Architektur und starkem Design auf den Bildschirm.
              </p>

              <div className="max-w-sm">
                <ScrambleButton href="#contact" text="Jetzt anfragen" accentColor="emerald" />
              </div>
            </div>
          </div>
        </div>
      </ContentWrapper>
    </div>
  );
}
